import * as Yup from 'yup'
import { BaseEntity } from '../../../../shared/models/ApiModels'

export interface IBranchModel extends BaseEntity{ 
  branchName: string
  webName: string
  status: string
  relatedOffice: string
  address: string
  district: string
  city: string
  email: string
  phone: string
  branchInfo: string
  companyTitle: string
  webReservationHour: string
  latitude: string
  longitude: string
  rentalCommissionRate: string
  serviceCommissionRate: string
  oldOffice: string
  newBranchName: string
  reservationColor: string
  isShoppingBranch: boolean
  webOrder: number
  webParkingId: string
  dealerId: string
  onlineReservationId: string
  contractFormat: string
  contractNo: string
  cashNo: string
  bankNo: string
  specialService1: string
  specialService2: string
  specialService3: string
  specialService4: string
  specialService5: string
  specialService6: string
  specialService7: string
  specialService8: string
  specialService9: string
  specialService10: string
  mondayWorkingHoursStart: string
  mondayWorkingHoursEnd: string
  tuesdayWorkingHoursStart: string
  tuesdayWorkingHoursEnd: string
  wednesdayWorkingHoursStart: string
  wednesdayWorkingHoursEnd: string
  thursdayWorkingHoursStart: string
  thursdayWorkingHoursEnd: string
  fridayWorkingHoursStart: string
  fridayWorkingHoursEnd: string
  saturdayWorkingHoursStart: string
  saturdayWorkingHoursEnd: string
  sundayWorkingHoursStart: string
  sundayWorkingHoursEnd: string
}

export const validationBranch = Yup.object().shape({
  branchName: Yup.string().required('Şube Adı zorunludur'),  
  webName: Yup.string().required('Web Adı zorunludur'), 
  status: Yup.string().required('Durum zorunludur'),
  address: Yup.string().required('Adres zorunludur'),
  district: Yup.string().required('İl zorunludur'),
  city: Yup.string().required('İlçe zorunludur'),
  email: Yup.string().required('Email zorunludur'),
  phone: Yup.string().required('Telefon zorunludur'),  
})

export const initialBranch: IBranchModel = {
  id: '', 
  branchName: '',
  webName: '',
  status: '1',
  relatedOffice: '-1',
  address: '',
  district: '',
  city: '',
  email: '',
  phone: '',
  branchInfo: '',
  companyTitle: '',
  webReservationHour: '',
  latitude: '',
  longitude: '',
  rentalCommissionRate: '',
  serviceCommissionRate: '',
  oldOffice: '',
  newBranchName: '',
  reservationColor: '#ffffff',
  isShoppingBranch: false,
  webOrder: 9999,
  webParkingId: '',
  dealerId: '',
  onlineReservationId: '',
  contractFormat: '',
  contractNo: '',
  cashNo: '',
  bankNo: '',
  specialService1: '',
  specialService2: '',
  specialService3: '',
  specialService4: '',
  specialService5: '',
  specialService6: '',
  specialService7: '',
  specialService8: '',
  specialService9: '',
  specialService10: '',
  mondayWorkingHoursStart: '',
  mondayWorkingHoursEnd: '',
  tuesdayWorkingHoursStart: '',
  tuesdayWorkingHoursEnd: '',
  wednesdayWorkingHoursStart: '',
  wednesdayWorkingHoursEnd: '',
  thursdayWorkingHoursStart: '',
  thursdayWorkingHoursEnd: '',
  fridayWorkingHoursStart: '',
  fridayWorkingHoursEnd: '',
  saturdayWorkingHoursStart: '',
  saturdayWorkingHoursEnd: '',
  sundayWorkingHoursStart: '',
  sundayWorkingHoursEnd: '',
}

export const RELATED_OFFICE = [{value: '-1', label: 'Yeni Şube'}] as const
